import { handle } from 'redux-pack';
import { 
	LOAD_MASKS,
} from '../actions/masks';
import { ActiveMasksEntity, ProfileMask, ProfileMaskEntity } from '../types/masks';
import { EntityType } from '../../types/enums';
import { Action } from '../types/types';

export interface MasksState {
	loading: boolean;
	loaded: boolean;
	profileMasks: Record<string | number, ProfileMask>;
	profileMaskEntities: Array<ProfileMaskEntity>;
	activeMasksEntity: ActiveMasksEntity | null;
}

export const initialMasksState: MasksState = {
	loading: false,
	loaded: false,
	profileMasks: {},
	profileMaskEntities: [],
	activeMasksEntity: null,
}

const actions: Map<string, Function> = new Map([
	[
		LOAD_MASKS,
		(state: MasksState, action: Action): MasksState => handle(state, action, {
			start: (state) => ({ 
				...state,
				loading: true,
			}),
			finish: (state) => ({ 
				...state,
				loading: false
			}),
			failure: (state) => ({ 
				...state,
				loading: false
			}),
			success: (state) => ({
				...state,
				profileMasks: action.payload?.profileMasks ?? state.profileMasks,
				activeMasksEntity: action.payload?.activeMasksEntity ?? state.activeMasksEntity,
				profileMaskEntities: action.payload?.profileMaskEntities ?? state.profileMaskEntities,
				loaded: true,
			}),
		}),
	],
	[EntityType.profileMask, (state: MasksState, action: Action) => {
		const profileMaskEntities = state.profileMaskEntities.map((e: ProfileMaskEntity) => {
			if (action?.payload?.entityId && e.entityId === action?.payload?.entityId) {
				return action.payload;
			}
			return e;
		});

		const profileMasks = {
			...state.profileMasks,
			[action.payload.entityValue?.id]: action.payload.entityValue,
		};
		
		return {
			...state,
			profileMaskEntities,
			profileMasks,
		};
	}],
	[EntityType.activeMasks, (state: MasksState, action: Action) => ({		
		...state,
		activeMasksEntity: action.payload
	})],
]);

export function MasksReducer(state: MasksState = initialMasksState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}